// extracted by mini-css-extract-plugin
module.exports = {"calendarItemHolder":"CalendarItem_calendarItemHolder__BiwmH","calendarItemHolderSafari":"CalendarItem_calendarItemHolderSafari__Nap9U"};